import { SET_APP_CONFIG } from '../Types';

const initialState = {
  routes: null,
  strings: null,
  screens: null,
  defaultConfig: null,
};

export const appConfig = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_CONFIG:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
